export enum VariantTranslationKeys {
  // TODO: temporary, should eventually be retrieved from schema/GQL
  description = 'Description',
  title = 'Title'
}
